<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Pesan WA`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <MessageWrapper :text-message="detailPesan.text">
                        <template v-slot:msg_head>
                            <div class="message-head f-13 f-regular f-c-black">
                                <div class="d-flex align-baseline">
                                    <label class="m-d-0 m-r-4 f-c-midgrey" style="min-width: 45px">Kepada: </label>
                                    <label class="m-d-0">{{ getMessage.to }} +{{ getMessage.telp }}</label>
                                </div>
                                <div class="d-flex align-baseline">
                                    <label class="m-d-0 m-r-4 f-c-midgrey" style="min-width: 45px">Jenis: </label>
                                    <label class="m-d-0"
                                        >{{ jenisTransaksi(detailPesan.jenis) }} • {{ getMessage.outlet }}</label
                                    >
                                </div>
                                <div class="d-flex align-baseline">
                                    <label class="m-d-0 m-r-4 f-c-midgrey" style="min-width: 45px">Waktu: </label>
                                    <label class="m-d-0 m-r-4">
                                        {{ $moment(getMessage.status_at).format("Do MMM YYYY, HH:mm") }}
                                    </label>
                                    <div
                                        class="status-pesan"
                                        :class="{
                                            warning:
                                                statusPesan(detailPesan.status) === 'Antrian' ||
                                                statusPesan(detailPesan.status) === 'Diproses',
                                            gagal: statusPesan(detailPesan.status) === 'Gagal',
                                            sukses: statusPesan(detailPesan.status) === 'Terkirim',
                                        }"
                                    >
                                        <label class="m-d-0 ">
                                            {{ statusPesan(detailPesan.status) }}
                                        </label>
                                    </div>
                                    <button
                                        class="btn-share m-l-4"
                                        @click="doResendMessage"
                                        v-if="statusPesan(detailPesan.status) === 'Gagal'"
                                        :disabled="isFetching"
                                    >
                                        <span
                                            class="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                            v-if="isFetching"
                                        ></span>
                                        <div v-else>
                                            <SOIconBase width="13" height="13" view-box="0 0 24 24">
                                                <template v-slot:icon>
                                                    <Mail2424 icon-fill="#206CFF" />
                                                </template>
                                            </SOIconBase>
                                            <span class="m-l-4">Kirim Ulang</span>
                                        </div>
                                    </button>
                                </div>
                                <div class="f-c-red f-12 f-regular" v-if="statusPesan(detailPesan.status) === 'Gagal'">
                                    <SOIconBase width="12" height="12" viewBox="0 0 18 17">
                                        <template v-slot:icon>
                                            <WarningTriangle1817 icon-fill="#964040" />
                                        </template>
                                    </SOIconBase>
                                    {{ detailPesan.reason }}
                                </div>
                            </div>
                        </template>
                    </MessageWrapper>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import MessageWrapper from "../MessageWrapper.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";
import Mail2424 from "@/so-components/global/icons/iconPacks/Mail2424.vue";

import { moduleName } from "../../store/state";
export default {
    name: "DetailMessage",
    components: {
        SOSlotModal,
        MessageWrapper,
        SOIconBase,
        WarningTriangle1817,
        Mail2424,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.riwayat_pesan",
            modalId: "detail-message",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    computed: {
        ...mapGetters(moduleName, {
            detailPesan: "detailPesan",
            jenisTransaksi: "getJenisTransaksi",
            statusPesan: "getStatusPesan",
            customer: "customer",
        }),
        getMessage() {
            return this.detailPesan;
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
    },
    methods: {
        ...mapActions({
            getHistoryPesanV2: `${moduleName}/getHistoryPesanV2`,
            getDetailHistoryPesan: `${moduleName}/getDetailHistoryPesan`,
            resendMessage: `${moduleName}/resendMessage`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            resetListPesan: `${moduleName}/resetListPesan`,
            resetPagePesan: `${moduleName}/resetPagePesan`,
        }),
        init() {
            this.getDetailHistoryPesan({ id_pesan: this.$route.params.id_message });
        },
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        doResendMessage() {
            let id_pesan = this.$route.params.id_message;

            this.resendMessage({ id_pesan })
                .then((res) => {
                    let { status, code, data, msg } = res.data;
                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.getDetailHistoryPesan({ id_pesan });
                        this.reloadList();
                        this.setResponse(resulter.successResult(msg));
                    } else {
                        this.$toast.error(msg);
                        this.setResponse(resulter.errorResult(msg));
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
        async reloadList() {
            let { number } = this.customer;
            await this.resetListPesan();
            await this.resetPagePesan();
            await this.getHistoryPesanV2({ idMesin: this.getIdDevice, nomor: number !== "all" ? number : "" });
        },
    },
};
</script>
<style scoped>
.message-head {
    background: #ffffff;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 8px 12px;
}
.btn-share {
    border: 1px solid;
    border-radius: 3px;
    box-sizing: border-box;
    background: white;
    color: #206cff;
    font-size: 11px;
    padding: 0px 3px;
    display: flex;
    align-items: center;
}
.status-pesan {
    width: fit-content;
    padding: 0px 4px;
    border-radius: 3px;
}
.gagal {
    background-color: #fff1f1;
    color: #964040;
}
.sukses {
    background-color: #e8fcee;
    color: #40964c;
}
.warning {
    background-color: #fff8e1;
    color: #c29500;
}
</style>
